<template>
  <v-dialog v-model="dialog" max-width="350">
    <div class="scartati">
      <v-card>
        <v-card-title class="cyan headline">
          <span class="white--text">Scarta calciatori</span>
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <!-- body -->
        <asta-svincolati
          :maxQuotazione="999999999999"
          :dialogParent="dialog"
          showButtonsScartaRiabilita
          :showStats="false"
          :showMainStatus="false"
          :showCuori="false"
          :showButtonScartati="false"
          showQuotazioni
          disableSelection
        >
          <template #footer="{ ruoloClassic, ruoliMantra }">
            <div class="d-flex align-center px-4 pt-3">
              <v-divider />
              <span class="mx-3 caption">oppure</span>
              <v-divider />
            </div>
            <section class="batch-scartati pa-4">
              <div class="batch-scartati-button" role="group" aria-label="Scarto per quotazione">
                <v-btn
                  depressed
                  class="batch-scartati-action cyan white--text"
                  :loading="scartando"
                  :disabled="!admin || !scartabili(ruoloClassic, ruoliMantra).length"
                  @click="scartaInBatch(ruoloClassic, ruoliMantra)"
                >
                  Scarta se quotazione &le;
                </v-btn>
                <v-menu offset-y max-height="300">
                  <template #activator="{ on, attrs }">
                    <v-btn
                      depressed
                      class="batch-scartati-dropdown cyan darken-1 white--text"
                      :disabled="scartando"
                      aria-label="Scegli la quotazione massima"
                      v-bind="attrs"
                      v-on="on"
                    >
                      {{ maxQuotazioneScarto }}
                      <v-icon small>expand_more</v-icon>
                    </v-btn>
                  </template>
                  <v-list dense>
                    <v-list-item
                      v-for="value in soglieQuotazione"
                      :key="value"
                      :input-value="maxQuotazioneScarto === value"
                      color="cyan"
                      @click="maxQuotazioneScarto = value"
                    >
                      <v-list-item-title>{{ value }}</v-list-item-title>
                      <v-list-item-icon>
                        <v-icon v-if="maxQuotazioneScarto === value" small color="cyan">check</v-icon>
                      </v-list-item-icon>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>

              <p class="batch-scartati-help mt-1 mb-0">
                Scarta calciatori con quotazione inferiore o uguale alla soglia scelta.<br>
                Verranno scartati solo quelli del ruolo selezionato.
              </p>
              <div class="batch-scartati-result" aria-live="polite">
                Con l'attuale soglia scelta ( quotazione >= {{ maxQuotazioneScarto }})
                <template v-if="!scartabili(ruoloClassic, ruoliMantra).length">Nessun calciatore verrá scartato.</template>
                <template v-else>{{ scartabili(ruoloClassic, ruoliMantra).length }} {{ scartabili(ruoloClassic, ruoliMantra).length === 1 ? 'calciatore sarà scartato' : 'calciatori saranno scartati' }}</template>
              </div>
            </section>
          </template>
        </asta-svincolati>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import mixins from "../../js/mixins";
import Vuex from "vuex";
import AstaSvincolati from "@/components/AstaSvincolati";

export default {
  name: "dialog-scarta-calciatori",
  mixins: [mixins],
  components: { AstaSvincolati },
  data() {
    return {
      dialog: false,
      maxQuotazioneScarto: 1,
      soglieQuotazione: [10, 9, 8, 7, 6, 5, 4, 3, 2, 1],
      scartando: false,
    };
  },
  mounted() {
    console.log("--> AstaScartatiAggiungi ready.");
    db.on("manageAggiungiScartati", this.show);
  },
  destroyed() {
    console.log("<-- AstaScartatiAggiungi destroyed.");
    db.off("manageAggiungiScartati", this.show);
  },
  methods: {
    scartabili(ruoloClassic, ruoliMantra) {
      if (!this.sogliaScartoValida) return [];
      const max = Number(this.maxQuotazioneScarto);

      return this.svincolati(ruoloClassic, "", 0, false, [], ruoliMantra)
        .filter((id) => {
          const quotazione = this.calciatori[id].quotazione;
          return id != this.asta_round.calciatoreInAsta &&
            quotazione !== null && quotazione !== undefined && quotazione !== "" &&
            Number.isFinite(Number(quotazione)) && Number(quotazione) <= max;
        });
    },
    async scartaInBatch(ruoloClassic, ruoliMantra) {
      if (this.scartando) return;
      if (!this.admin) {
        db.emit("swalAdmin");
        return;
      }
      const ids = this.scartabili(ruoloClassic, ruoliMantra);
      if (!ids.length) return;

      this.scartando = true;
      try {
        await db.scartaCalciatori(ids);
        await Promise.all(ids.map((id) => this.astaLogScartato(id)));
      } catch (error) {
        this.errorToast("Errore", "Impossibile completare lo scarto multiplo. Verifica la lista e riprova.");
      } finally {
        this.scartando = false;
      }
    },
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
  },
  computed: {
    sogliaScartoValida() {
      return this.soglieQuotazione.includes(this.maxQuotazioneScarto);
    },
  },
};
</script>
<style lang="scss" scoped>
.batch-scartati-button {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 56px;
}
.batch-scartati-action.v-btn {
  min-width: 0;
  padding: 0 6px;
  height: auto;
  min-height: 36px;
  border-radius: 4px 0 0 4px;
  font-size: 12px;
  letter-spacing: 0;
}
.batch-scartati-action::v-deep .v-btn__content {
  white-space: normal;
  line-height: 1.3;
  padding: 6px 0;
}
.batch-scartati-dropdown.v-btn {
  min-width: 0;
  padding: 0;
  border-radius: 0 4px 4px 0;
  height: auto;
  min-height: 36px;
}
.batch-scartati-result {
  font-size: 12px;
  min-height: 18px;
  font-weight: 600;
}
.batch-scartati-help {
  font-size: 12px;
  line-height: 1.4;
}
</style>
